/**
 * HostSettingsPage
 *
 * Profile settings wrapped in HostLayout so hosts
 * stay within the host dashboard context.
 */

import React from 'react';
import { HostLayout } from './components/HostLayout';
import { ProfilePage } from '../Dashboard/ProfilePage';

export const HostSettingsPage: React.FC = () => (
  <HostLayout title="Settings">
    <ProfilePage embedded />
  </HostLayout>
);

export default HostSettingsPage;
